export function trackToGtmFE(eventName, eventProperties) {
    if(typeof dataLayer != "undefined"){
        trackToGtm(dataLayer,eventName,eventName,eventProperties);
    }
  }